import {
  ElInput,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElCarousel,
  ElCarouselItem,
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElLoading,
} from 'element-plus';
import 'element-plus/dist/index.css';

export function installElementPlus(app) {
  // Register commonly used components
  app.component('ElInput', ElInput);
  app.component('ElForm', ElForm);
  app.component('ElFormItem', ElFormItem);
  app.component('ElSelect', ElSelect);
  app.component('ElOption', ElOption);
  app.component('ElCarousel', ElCarousel);
  app.component('ElCarouselItem', ElCarouselItem);

  // Expose Element Plus services on globalProperties
  app.config.globalProperties.$message = ElMessage;
  app.config.globalProperties.$msgbox = ElMessageBox;
  app.config.globalProperties.$notify = ElNotification;
  app.config.globalProperties.$loading = ElLoading.service;

  // Optional style overrides (moved from main.js)
  const style = document.createElement('style');
  style.textContent = `
  .el-input__wrapper.is-focus {
    border-color: red !important;
    box-shadow: 0 0 0 1px red !important;
  }
  
  .el-textarea__inner:focus {
    border-color: #0d72ff !important;
    box-shadow: 0 0 0 1px #0d72ff !important;
  }
  
  .el-select__wrapper.is-focus {
    border-color: #0d72ff !important;
    box-shadow: 0 0 0 1px #0d72ff !important;
  }
  
  /* el-option dropdown styles */
  .el-select-dropdown__item {
    color: #606266 !important;
  }
  .el-select-dropdown__item:hover {
    background-color: #f5f7fa !important;
    color: #0D72FF !important;
  }
  .el-select-dropdown__item.selected {
    color: #0D72FF !important;
    font-weight: bold !important;
  }
  .el-select-dropdown__item.selected:hover {
    background-color: #ecf5ff !important;
    color: #0D72FF !important;
  }
  
  :root {
    --el-color-primary: red !important;
    --el-border-color-focus: red !important;
  }
`;
  document.head.appendChild(style);
}

export default installElementPlus;
